import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import ReactMarkdown from 'react-markdown'

import Accordion from '../../components/Accordion'

const StyledWrapper = styled.div`
  margin: 0 auto;
  padding: 64px 0 88px;
  width: 90%;

  ${({ theme }) => theme.media.desktop} {
    width: 819px;
  }
  > div {
    border-bottom: 1px solid #e9ebef;
  }
`

const StyledHeader = styled.div`
  border-top: 1px solid #e9ebef;
  color: ${({ theme }) => theme.colors.darkBlue};
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.88;
  outline: none;
  padding: 24px 70px 24px 24px;
  position: relative;
  text-align: left;

  ${({ theme }) => theme.media.desktop} {
    padding: 24px;
  }

  &:after,
  &:before {
    background-color: #98a1b1;
    border-radius: 20px;
    content: '';
    display: inline-block;
    position: absolute;
    transition: 250ms;
  }

  &:before {
    content: '';
    height: 17px;
    right: 31px;
    top: calc(50% - 9px);
    width: 2px;

    ${({ active }) =>
      active &&
      css`
        opacity: 0;
        transform: scaleY(0);
      `}
  }

  &:after {
    height: 2px;
    right: 24px;
    top: calc(50% - 2px);
    width: 17px;
  }
`

const StyledContent = styled.div`
  padding: 0 24px 24px;

  a {
    text-decoration: underline;
  }

  ul {
    color: #4e5d78;
    display: block;
    font-size: 0.875em;
    line-height: 1.71;
    list-style-type: disc;
    margin-block-end: 1em;
    margin-block-start: 1em;
    margin-inline-end: 0px;
    margin-inline-start: 0px;
    max-height: 400px;
    padding-inline-start: 40px;
    text-align: left;
  }

  p {
    color: ${({ theme }) => theme.colors.greyParagraphColor};
    font-size: 0.875em;
    line-height: 1.71;
    max-height: 400px;
    text-align: left;
  }
`

const FAQ = ({ data }) => {
  const [activeQuestion, setActiveQuestion] = useState(null)

  const handleClick = e => {
    activeQuestion !== e ? setActiveQuestion(e) : setActiveQuestion(null)
  }

  return (
    <StyledWrapper>
      <div>
        {data.map(question => (
          <Accordion
            key={question.id}
            active={activeQuestion === question.id}
            header={
              <StyledHeader active={activeQuestion === question.id}>
                {question.question}
              </StyledHeader>
            }
            onClick={() => handleClick(question.id)}
          >
            <StyledContent>
              <ReactMarkdown source={question.answer.answer} />
            </StyledContent>
          </Accordion>
        ))}
      </div>
    </StyledWrapper>
  )
}

FAQ.propTypes = {}

export default FAQ
